export const userCommunitiesQueryKey = 'communities';
export const memberQueryKey = 'member';
export const communityMembersQueryKey = 'members';
export const communityInvitationsQueryKey = 'invitations';
export const documentsQueryKey = 'documents';

// superadmin query keys
export const allUsersQueryKey = 'users';
export const allCommunitiesQueryKey = 'communities';
